import {
    LocalForageTaskQueue,
    Task
} from "@tenera/upload_workers";

import AttachmentUploadRequest from "../request/AttachmentUploadRequest";
import { AttachmentUploadStatus } from "../status/AttachmentUploadStatus";
import localforage from "localforage";

class AttachmentUploadQueueFactory {
    private static readonly INSTANCE: LocalForageTaskQueue<Task<AttachmentUploadRequest, AttachmentUploadStatus>> = 
        new LocalForageTaskQueue<Task<AttachmentUploadRequest, AttachmentUploadStatus>>(localforage.createInstance({
            name: "attachment_upload_queue"
        }));

    public static getInstance(): LocalForageTaskQueue<Task<AttachmentUploadRequest, AttachmentUploadStatus>> {
        return AttachmentUploadQueueFactory.INSTANCE;
    }
}

export const attachmentUploadQueue = AttachmentUploadQueueFactory.getInstance();